import {
	scheduleServiceCallForBuyer,
	scheduleServiceCallForSupplier,
} from '../../thunks/work_orders_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Alert, Button, DatePicker, Form, Modal, Select } from 'antd';
import moment from 'moment';
import * as React from 'react';
import { DATE_FORMAT } from '../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import { useState } from 'react';
import OWForm from '../ow_form/OWForm';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

const BuyerScheduleServiceCall = ({
	creating,
	updating,
	createErrors,
	updateErrors,
	workOrder,

	scheduleServiceCall,
}) => {
	const [form] = Form.useForm();
	const [visible, setVisible] = useState(false);
	const onSubmit = (values) => {
		scheduleServiceCall({
			...values,
			workOrderId: workOrder.id,
			supplierFacilityId: workOrder.supplierFacilityId,
		});
	};
	const disabledDate = (current) => {
		// Can not select days before today and today
		return current < moment().startOf('day');
	};

	return (
		<>
			<Button
				type="primary"
				key="start"
				onClick={() => setVisible(true)}
				style={{ marginRight: 16 }}
			>
				Schedule Work
			</Button>
			<Modal
				visible={visible}
				width={600}
				title={'Schedule Service'}
				okText={'Schedule'}
				onCancel={() => setVisible(false)}
				onOk={form.submit}
				closable={false}
				confirmLoading={creating || updating}
			>
				<OWForm
					form={form}
					layout="vertical"
					preserve={false}
					onFinish={onSubmit}
					actionCreators={WORK_ORDERS_CRUD_ACTION_CREATORS}
				>
					{createErrors.length > 0 ? (
						<Form.Item>
							<Alert message={createErrors.join(' ')} type="error" />
						</Form.Item>
					) : null}
					{updateErrors.length > 0 ? (
						<Form.Item>
							<Alert message={updateErrors.join(' ')} type="error" />
						</Form.Item>
					) : null}
					<Form.Item
						label="Scheduled Arrival Time"
						rules={[
							{
								type: 'object',
								required: true,
								message: 'Please select an estimated arrival time.',
							},
						]}
						initialValue={
							workOrder.serviceScheduledAt ? moment(workOrder.serviceScheduledAt) : undefined
						}
						name={'serviceScheduledAt'}
					>
						<DatePicker
							disabledDate={disabledDate}
							style={{ width: '100%' }}
							showTime={true}
							format={DATE_FORMAT}
						/>
					</Form.Item>
				</OWForm>
			</Modal>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config,

	createErrors: state.buyer_contacts.createErrors,
	updateErrors: state.buyer_contacts.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	scheduleServiceCall: (serviceCall) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? scheduleServiceCallForSupplier(serviceCall)
				: scheduleServiceCallForBuyer(serviceCall)
		),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(BuyerScheduleServiceCall))
);
